<template>
  <div class="ue" :class="isAuthPage">
    <img src="@/assets/ue.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'ue-footer',
  computed: {
    isAuthPage() {
      const routerName = this.$route.name;
      const isAuth = routerName === 'login'
        || routerName === 'reset-password'
        || routerName === 'recive-password';
      return isAuth ? 'ue--login' : '';
    },
  },
};
</script>
